import React from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Box,
} from "@mui/material";
import { Email, LocationOn, Business } from "@mui/icons-material";
import Navbar from "../component/common/Navbar";

const HelpCenter = () => {
  return (
    <>
      <Navbar />
      <Container
        style={{ paddingTop: 120 }}
        maxWidth="md"
        sx={{
          py: 4,
          backgroundColor: "#121212",
          minHeight: "100vh",
          color: "#fff",
        }}
      >
        {/* Hero Section */}
        <Box textAlign="center" mb={4}>
          <Typography className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight" style={{fontSize:"1.8rem",fontWeight:"700"}}> PlayGG - Help Center
          </Typography>
          <Typography variant="body1" color="#ccc" gutterBottom>
            How can we assist you today?
          </Typography>
        </Box>

        {/* Contact Section */}
        <Card sx={{ mb: 4, backgroundColor: "#1E1E1E", color: "#fff" }}>
          <CardContent>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contact Us
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} display="flex" alignItems="center">
                <Email sx={{ color: "#4FC3F7", mr: 1 }} />
                <Typography variant="body1" color="#ccc">
                  contact@playgg.in
                </Typography>
              </Grid>
              <Grid item xs={12} display="flex" alignItems="center">
                <LocationOn sx={{ color: "#4FC3F7", mr: 1 }} />
                <Typography variant="body1" color="#ccc">
                  H-1-105, ROAD NO.5 B, RIICO IND. AREA, CHURU, RAJASTHAN
                </Typography>
              </Grid>
              <Grid item xs={12} display="flex" alignItems="center">
                <Business sx={{ color: "#4FC3F7", mr: 1 }} />
                <Typography variant="body1" color="#ccc">
                  WEIRD ESPORTS INDIA PRIVATE LIMITED
                  <br />
                  CIN: U92412RJ2021PTC077138
                  <br />
                  Incorporated on 23 Dec 2021
                  <br />
                  Registered at Registrar of Companies, Jaipur, Rajasthan
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* FAQ Section */}
        <Box>
          <Card sx={{ mb: 2, backgroundColor: "#1E1E1E", color: "#fff" }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold">
                How can I contact customer support?
              </Typography>
              <Typography variant="body2" color="#ccc">
                You can reach us via email at contact@playgg.in.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default HelpCenter;
